import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';
import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';
import type { AxiosRequestConfig } from 'axios';
import { initCookieService } from '@eureka/utils/init-cookie';

let fingerprint = '';

export const fingerprintInterceptor = async(config: AxiosRequestConfig) => {
    if (!fingerprint) {
        fingerprint = initCookieService.getVisitorId() || await getBrowserFingerprint();
    }
    config.headers = _.merge({}, config.headers, {
        'X-Signature-ID': fingerprint,
    })
    return config;
};

export function injectFingerprintInterceptor() {
    if (!psAxios.psInterceptors.fingerprintInterceptor) {
        psAxios.psInterceptors.fingerprintInterceptor = psAxios.interceptors.request.use(fingerprintInterceptor, () => { });
    }
}

export function ejectFingerprintInterceptor() {
    psAxios.interceptors.request.eject(
        psAxios.psInterceptors.fingerprintInterceptor
    );
}
